import React from "react"
import styled from 'styled-components'
import { Input, CustomInput } from 'reactstrap'
import get from 'lodash/get'
import SearchIcon from "../../static/images/search_icon.svg"
import { FONTS } from '../../constants'

export default class SearchBarConsentLogs extends React.Component {

  render() {
    return (
      <Wrapper>
        <WrapperButton>

          <SearchField
            placeholder={ 'Search By Name, ID' }
            value={ get(this.props, 'search') }
            onChange={ get(this.props, 'handleSearch') }
            onKeyDown={ get(this.props, 'handleSearch') }
          />
            <CustomInputField
              id='selectedStatus'
              type="select"
              value={ get(this.props, 'selectedStatus') }
              onChange={ (e) => this.props.handleInputStatus(e) }
            >
              <option key='All' value=''>{ 'Select Status' }</option>
              <option key='ACCEPTED' value='ACCEPTED'>{ 'ACCEPTED' }</option>
              <option key='PENDING' value='PENDING'>{ 'PENDING' }</option>
            </CustomInputField>
        </WrapperButton>
      </Wrapper>
    )
  }
}

const WrapperButton = styled.div`
  display: flex;
  margin-left: 1%;
  margin-right: 1%;
`
const Wrapper = styled.div`
  background-color: #ffffff ;
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  margin-bottom: 5px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  align-items: center;
  box-shadow: 0px 3px 10px -7px black;
`
const SearchField = styled(Input)`
  height: 30px;
  width: 300px;
  padding-left: 30px;
  background: url(${SearchIcon}) no-repeat scroll 3%;
  background-size: 15px 15px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  border: 1px solid #ccc;
  border-radius: 4px;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
  }
`
const CustomInputField = styled(CustomInput)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  height: 30px;
`


// WEBPACK FOOTER //
// ./src/components/searchbar-consent-logs/index.js